var $5cbb62c8a19173ac$exports = {};
$5cbb62c8a19173ac$exports = {
  "deselectedItem": function deselectedItem(args) {
    return "".concat(args.item, " pole valitud.");
  },
  "longPressToSelect": "Valikure\u017Eiimi sisenemiseks vajutage pikalt.",
  "select": "Vali",
  "selectedAll": "K\xF5ik \xFCksused valitud.",
  "selectedCount": function selectedCount(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      "=0": "\xDCksusi pole valitud",
      one: function one() {
        return "".concat(formatter.number(args.count), " \xFCksus valitud");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " \xFCksust valitud");
      }
    }), ".");
  },
  "selectedItem": function selectedItem(args) {
    return "".concat(args.item, " valitud.");
  }
};
export { $5cbb62c8a19173ac$exports as default };